import Immutable from 'immutable';
import {
  FLAG_GETTING_BUS_ACTIVITY_ASSIGNMENTS,
  GET_BUS_ACTIVITY_ASSIGNMENTS,
  CLEAR_BUS_ACTIVITY_ASSIGNMENTS,
  FLAG_BUS_ACTIVITY_ASSIGNMENT_ACTIVITY,
  CLEAR_BUS_ACTIVITY_ASSIGNMENT,
  GET_BUS_ACTIVITY_ASSIGNMENT,
} from '../../../actions/types/mechanical-maintenance';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_BUS_ACTIVITY_ASSIGNMENTS:
      return state.setIn(['all', 'loading'], payload);
    case GET_BUS_ACTIVITY_ASSIGNMENTS:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_BUS_ACTIVITY_ASSIGNMENTS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_BUS_ACTIVITY_ASSIGNMENT_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_BUS_ACTIVITY_ASSIGNMENT:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_BUS_ACTIVITY_ASSIGNMENT:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
